import whiteNoise from '../white-noise.gif';

function Frame({ selectedStream }) {
    const link = selectedStream
        ? `https://chzzk.naver.com/live/${selectedStream.channelId}` : '#';
    return (
        <div className="frameDiv" style={{
            width: "100%",
            aspectRatio: "16/9",
            borderRadius: "8px",
            backgroundColor: "#000000",
            overflow: "hidden",
        }}>
            {selectedStream ?
                <iframe className="frame" title="CHZZK Player" src={link} frameborder="0" allow="autoplay; clipboard-write; web-share" scrolling="no"></iframe>
                : <img src={whiteNoise} style={{ width: "100%", height: "100%", }}></img>
            }
        </div>
    );
}

export default Frame;